<div class="agGridOuterDiv" style="margin-top: 15px;">

    <mat-toolbar class="agGridtopersDiv card" style="
        background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
        border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
        <label i18n="@@spmsUserReg" style="color: gray;">Dataset</label>

        <span class="example-spacer"></span>

        <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                <input matInput type="text" (input)="onSearchChange($event.target.value)">
            </mat-form-field>
        </div>
        <div class="selectRecordsDiv" style="width:9.5%">
            <mat-form-field appearance="outline" style="width:100%">
                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                    <mat-option value="10" selected>10</mat-option>
                    <mat-option value="200">200</mat-option>
                    <mat-option value="300">300</mat-option>
                    <mat-option value="400">400</mat-option>
                </mat-select>

            </mat-form-field>
        </div>
        <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
            <ul>
                <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                        (click)="onBtPrevious()"></em></li>
                <li>{{currentPage}}/{{totalPages}}</li>
                <li class="paginationliicon" style="padding:0;"><em
                        class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
            </ul>
        </div>
        <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
        </div>
    </mat-toolbar>
    <ag-grid-angular class="ag-theme-balham table-width-static-fulfilment-return tablestyles square scroolbar-dusty-grass square thin"
    [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef"
    [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
    [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
    [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
    [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
    [components]="components" (gridReady)="onGridReady($event)" 
    [hidden]="!true">
</ag-grid-angular>

<div style="text-align: end;margin-top: 5px;margin-bottom: 8px;">
        <button i18n="@@TargetCancel" type="button" (click)="closePopup()"
        class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
        style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;" >Close</button>
</div>

</div>


